// see alltrails_analytics_definition/definitions/enums/WebProPurchaseLocation.json
enum WebProPurchaseLocation {
  GiftPage = 'gift page',
  ProPage = 'pro page'
}

export default WebProPurchaseLocation;
